import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ArchidriveComponent } from './archidrive';
import './archidrive.scss';
import { ArchidriveFilterModule } from './archidrive-filter/archidrive-filter.module';
import { ArchidriveNewFolderModule } from './archidrive-new-folder/archidrive-new-folder.module';
import { ArchidriveRenameModule } from './archidrive-rename/archidrive-rename.module';
import { ArchidriveMoveModule } from './archidrive-move/archidrive-move.module';
import { ArchidriveShareModule } from './archidrive-share/archidrive-share.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.archidrive', {
            url: '/archidrive/:file',
            params: {
                file: ''
            },
            ncyBreadcrumb: {
                label: 'Archivia',
                parent: 'home.home-index'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Archivia'
            },
            'views': {
                'homeContent': {
                    template: '<archidrive flex="100"></archidrive>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ArchidriveModule: string = ng
    .module('archidrive', [
        'ui.bootstrap',
        uiRouter,
        ArchidriveFilterModule,
        ArchidriveNewFolderModule,
        ArchidriveRenameModule,
        ArchidriveMoveModule,
        ArchidriveShareModule
    ])
    .component('archidrive', ArchidriveComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive.module.ts